import { BaseEitherError } from '@uniqkey-frontend/shared-app';

export class SupportJumpRefreshSupportTokensMissingUserTokenError extends BaseEitherError {}

export class SupportJumpRefreshSupportTokensFetchError extends BaseEitherError {}

export type TSupportJumpRefreshSupportTokensOperationErrors =
  SupportJumpRefreshSupportTokensFetchError
  | SupportJumpRefreshSupportTokensMissingUserTokenError;
